var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.558,
    height: 19.753,
    viewBox: "0 0 18.558 19.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-5.994 -5.996)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M17.451,15.871l6.643-7.056a1.728,1.728,0,0,0,0-2.336,1.486,1.486,0,0,0-2.194,0l-6.628,7.072L8.645,6.48a1.486,1.486,0,0,0-2.194,0,1.728,1.728,0,0,0,0,2.336l6.643,7.056L6.451,22.927a1.72,1.72,0,0,0,0,2.336,1.48,1.48,0,0,0,2.194,0l6.628-7.072L21.9,25.263a1.48,1.48,0,0,0,2.194,0,1.72,1.72,0,0,0,0-2.336Z",
    transform: "translate(0 0)",
    fill: "#9a9a9a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.75daf30067cccf33aaf4dc7deceb94b2.svg";
export { ForwardRef as ReactComponent };